// extracted by mini-css-extract-plugin
module.exports = {"SectionHeader":"SectionHeader--3tH8K","Title":"Title--3um41"};